module.exports = __webpack_public_path__ + "media/images/timbres_honorarios_ico-7f7996d2.png";